module.exports = __webpack_public_path__ + "img/image-jpg.4bf45a05.png";